import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Observable } from 'rxjs';
import { ListForecastYear } from 'src/app/core/models/forecast.models';
import {
	ForecastCampaignPeriods,
	ForecastCampaignService,
	ForecastCampaignTypeService,
} from '../services/forecast-campaigns-list.service';
import { ListForecastServiceYear } from '../services/forecastyear-list.service';
import { ListForecastServiceYearSearch } from '../services/forecastyearsearch-list.service';
import { NgbdOrdersSortableHeaderYear } from '../listjs-sortable-forecast-list.directive';

@Component({
	selector: 'app-year',
	templateUrl: './year.component.html',
	styleUrls: ['./year.component.scss'],
	providers: [
		ListForecastServiceYear,
		ForecastCampaignService,
		ForecastCampaignTypeService,
	],
})
export class YearComponent {
	// bread crumb items
	breadCrumbItems!: Array<{}>;
	loadingExcel: boolean = false;
	submitted = false;
}
